<template>
  <div class="w-full max-w-270 text-app-color">
    <div class="w-full p-15 pt-10 pb-40 rounded-20"
         :class="isDarkMode ? 'bg-sidebar' : 'bg-green-600'"
    >
      <div class="text-center mt-30">
        <p class="text-26 font-semibold">TEAMS.</p>
        <p class="text-14">Real-time collaboration and project management.</p>
        <div class="text-center mt-20">
          <div class="flex items-start justify-center -ml-10">
            <span>$</span>
            <span class="text-35 font-bold">{{ price }}</span>
          </div>
          <p class="leading-0">per user / per month </p>
        </div>
      </div>

      <div class="text-center mt-35">
        <!-- :class="isDraculaTheme
            ? 'bg-notebooks-dracula-link hover:bg-canvasborder-notebooks-dracula-link'
            : isDarkMode
              ? 'bg-link-color hover:bg-canvas hover:text-link-color border-link-color'
              : 'border-blue-dark hover:bg-blue-dark hover:text-white '" -->
        <button
          class="border-2 rounded-full px-20 py-10 font-medium text-black anim-color
               bg-yellow-100 border-yellow-100 hover:bg-yellow-200 hover:border-yellow-200"
          :disabled="!isTrialPlan && !isExpired"
          @click="upgrade"
        >
          {{ btnTitle }}
        </button>
      </div>

      <div class="flex justify-center mt-30">
        <div>
          <div class="flex items-center mt-20">
            <p class="font-semibold">Everything in PRO plus...</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Team management</span> tools</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Admin</span> roles</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Shared</span> workspace</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">{{ storage }}</span> storage space</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Template</span> Creator</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    billAnnually: Boolean
  },

  setup (props) {
    const { state, getters } = useStore()

    const isDarkMode = computed(() => getters.isDarkMode)
    const isDraculaTheme = computed(() => state.settings.settings.theme === 'Dracula')
    const teamPlanMonthly = computed(() => getters.teamPlanMonthly)
    const teamPlanYearly = computed(() => getters.teamPlanYearly)
    const isTrialPlan = computed(() => getters.isTrialPlan)
    const isExpired = computed(() => getters.isExpired)

    const team = computed(() => state.team.team)
    const user = computed(() => state.profile.user)
    const currentPlan = computed(() => getters.currentPlan)

    const storage = computed(() => props.billAnnually ? '450GB' : '350GB')

    const price = computed(() => {
      if (!isTrialPlan.value) {
        return parseInt(currentPlan.value.pricePerMonth)
      }
      return props.billAnnually ? parseInt(teamPlanYearly.value.pricePerMonth) : parseInt(teamPlanMonthly.value.pricePerMonth)
    })

    const btnTitle = computed(() => {
      if (isExpired.value) return 'Renew'
      return isTrialPlan.value ? 'Upgrade to Teams' : 'Your current plan'
    })

    function upgrade () {
      window.open(`https://helloivy.co/upgrade?userId=${user.value.id}&teamId=${team.value.id}`, '_blank')
    }

    return {
      // computed
      isDarkMode,
      isDraculaTheme,
      price,
      btnTitle,
      isTrialPlan,
      isExpired,
      storage,
      // function
      upgrade
    }
  }
})
</script>
